import { Typography } from "@mui/material";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { APIError } from "src/types";
import { parseServerError } from "src/utils/string.utils";

interface Props {
  importErrors: APIError[];
}

export function ImportFailed(props: Props) {
  const { importErrors } = props;
  const { t } = useTranslation();

  return render();

  function render() {
    return (
      <StyledAlert icon={false} variant="standard" severity="error">
        <Typography variant="h3" gutterBottom>
          {t("label.thePreviousImportFailed")}
        </Typography>

        <Typography variant="body1" gutterBottom>
          {t("label.yourImportHasFailedDueToAndMore")}
        </Typography>

        <ul className="error-list">
          {importErrors.map((importError, i) => (
            <li key={i}>{parseServerError(importError)}</li>
          ))}
        </ul>
      </StyledAlert>
    );
  }
}

const StyledAlert = styled(Alert)`
  padding: ${({ theme }) => theme.spacing(2, 2)};

  .error-list {
    padding: ${({ theme }) => theme.spacing(0, 0)};
    padding-inline-start: ${({ theme }) => theme.spacing(2)};
  }
`;
